export const BASE_URL = process.env.BASE_URL || "";
export const API_KEY = process.env.API_KEY || "";
